export function getQuestionAnswerCounts(question) {
  if (!question) {
    return { correctCount: 0, topWrongCount: 0, wrongCount: 0 };
  }

  let correctCount = 0;
  let topWrongCount = 0;

  if (Array.isArray(question.distribution) && question.distribution.length > 0) {
    question.distribution.forEach((opt) => {
      const count = Number(opt.count) || 0;
      if (opt.is_correct) {
        correctCount = count;
      } else if (opt.option !== 'Unanswered') {
        topWrongCount = Math.max(topWrongCount, count);
      }
    });
  } else {
    const attempts = Number(question.attempts) || 0;
    const wrongCount = Number(question.wrong_count) || 0;
    correctCount = Math.max(0, attempts - wrongCount);
    topWrongCount = wrongCount;
  }

  return {
    correctCount,
    topWrongCount,
    wrongCount: Number(question.wrong_count) || 0,
  };
}

export function compareAnalyticsQuestions(a, b, column, direction) {
  const aStats = getQuestionAnswerCounts(a);
  const bStats = getQuestionAnswerCounts(b);

  const cmp = (aVal, bVal) => {
    if (aVal < bVal) return direction === 'asc' ? -1 : 1;
    if (aVal > bVal) return direction === 'asc' ? 1 : -1;
    return 0;
  };

  let primary = 0;

  if (column === 'text') {
    primary = cmp(
      (a.question_text || '').toLowerCase(),
      (b.question_text || '').toLowerCase()
    );
  } else if (column === 'pedagogy') {
    primary = cmp(
      (a.pedagogy || '').toLowerCase(),
      (b.pedagogy || '').toLowerCase()
    );
  } else if (column === 'correct_count') {
    primary = cmp(aStats.correctCount, bStats.correctCount);
  } else if (column === 'wrong_count') {
    primary = cmp(aStats.topWrongCount, bStats.topWrongCount);
  } else if (column === 'percentage') {
    const aPct = a.attempts ? ((a.attempts - (a.wrong_count || 0)) / a.attempts) * 100 : 0;
    const bPct = b.attempts ? ((b.attempts - (b.wrong_count || 0)) / b.attempts) * 100 : 0;
    primary = cmp(aPct, bPct);
  }

  if (primary !== 0) return primary;

  if (column === 'wrong_count' || column === 'correct_count') {
    if (aStats.topWrongCount !== bStats.topWrongCount) {
      return bStats.topWrongCount - aStats.topWrongCount;
    }
    if (aStats.correctCount !== bStats.correctCount) {
      return aStats.correctCount - bStats.correctCount;
    }
  }

  return ((a.question_text || '').toLowerCase()).localeCompare((b.question_text || '').toLowerCase());
}
